(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--atlas-header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--atlas-header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--atlas-header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["great-bite-cart-drawer"] && !Shopify.designMode) return;
  try {
    



(function () {



  // PAUSE GUARD: if the custom drawer markup is disabled, do not intercept cart clicks/forms.

  if (!document.querySelector('[data-gb-cart-root]')) return;



  if (window.GreatBiteCartDrawerV1) return;



  window.GreatBiteCartDrawerV1 = true;



  var ROOT_SELECTOR = '[data-gb-cart-root]';



  var rootPath = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';



  var lastFocus = null;



  var addRequestInFlight = false;



  function getVisibleCartCount() {



    var root = getRoot();



    if (root) {



      var local = root.querySelector('[data-gb-count]');



      if (local) {



        var n = parseInt(local.textContent, 10);



        if (!isNaN(n)) return n;



      }



    }



    var external = document.querySelector('[data-cart-count], .cart-count, [data-cart-item-count]');



    if (external) {



      var n2 = parseInt(external.textContent, 10);



      if (!isNaN(n2)) return n2;



    }



    return 0;



  }



  function optimisticCountAdd(quantity) {



    var next = getVisibleCartCount() + Math.max(1, parseInt(quantity, 10) || 1);



    syncCount(next);



    var root = getRoot();



    if (root) {



      var local = root.querySelector('[data-gb-count]');



      if (local) local.textContent = next;



    }



  }



  function getRoot() { return document.querySelector(ROOT_SELECTOR); }



  function getSectionId() { var root = getRoot(); return root ? root.dataset.sectionId : ''; }



  function getDrawer() { var root = getRoot(); return root ? root.querySelector('.gbcd__drawer') : null; }



  function setOpen(open) {



    var root = getRoot();



    if (!root) return;



    if (open) {



      if (!root.classList.contains('is-open')) {



        lastFocus = document.activeElement;



      }



      root.classList.add('is-open');



      root.setAttribute('aria-hidden', 'false');



      document.body.classList.add('gbcd-lock');



      requestAnimationFrame(function () {



        var drawer = getDrawer();



        if (drawer) drawer.focus({ preventScroll: true });



      });



    } else {



      root.classList.remove('is-open');



      root.setAttribute('aria-hidden', 'true');



      document.body.classList.remove('gbcd-lock');



      if (lastFocus && typeof lastFocus.focus === 'function') {



        lastFocus.focus({ preventScroll: true });



      }



    }



  }



  function setLoading(loading) {



    var root = getRoot();



    if (!root) return;



    root.classList.toggle('is-loading', loading);



    var indicator = root.querySelector('[data-gb-loading]');



    if (indicator) indicator.setAttribute('aria-hidden', loading ? 'false' : 'true');



  }



  function syncCount(count) {



    document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span:first-child, [data-cart-item-count]').forEach(function (el) {



      if (el.closest(ROOT_SELECTOR)) return;



      el.textContent = count;



      if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', count);



    });



  }



  function replaceSection(html, keepOpen) {



    if (!html) return false;



    var doc = new DOMParser().parseFromString(html, 'text/html');



    var incoming = doc.querySelector(ROOT_SELECTOR);



    var current = getRoot();



    if (!incoming || !current) return false;



    /*



      The drawer already animated open before the cart request.



      Preserve the open state on the server-rendered replacement instead



      of calling setOpen(true) again, which would replay the entrance.



    */



    if (keepOpen) {



      incoming.classList.add('is-open');



      incoming.setAttribute('aria-hidden', 'false');



    }



    current.replaceWith(incoming);



    if (keepOpen) {



      document.body.classList.add('gbcd-lock');



    }



    return true;



  }



  function sectionPayload() {



    return { sections: getSectionId(), sections_url: window.location.pathname + window.location.search };



  }



  function handleResponse(response, keepOpen) {



    if (!response.ok) {



      return response.json().catch(function () { return {}; }).then(function (data) {



        throw new Error(data.description || data.message || 'Cart update failed');



      });



    }



    return response.json().then(function (data) {



      var id = getSectionId();



      if (data.sections && data.sections[id]) replaceSection(data.sections[id], keepOpen);



      if (typeof data.item_count === 'number') syncCount(data.item_count);



      document.dispatchEvent(new CustomEvent('greatbite:cart:updated', { detail: data }));



      return data;



    });



  }



  function changeLine(key, quantity) {



    var payload = sectionPayload();



    payload.id = key;



    payload.quantity = Math.max(0, parseInt(quantity, 10) || 0);



    setLoading(true);



    return fetch(rootPath + 'cart/change.js', {



      method: 'POST',



      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },



      body: JSON.stringify(payload)



    }).then(function (response) { return handleResponse(response, true); })



      .catch(function (error) { console.error('[Great Bite cart]', error); })



      .finally(function () { setLoading(false); });



  }



  function changeSellingPlan(line, quantity, sellingPlanId) {



    var payload = sectionPayload();



    payload.line = Math.max(1, parseInt(line, 10) || 1);



    payload.quantity = Math.max(1, parseInt(quantity, 10) || 1);



    payload.selling_plan = Number(sellingPlanId);



    setLoading(true);



    return fetch(rootPath + 'cart/change.js', {



      method: 'POST',



      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },



      body: JSON.stringify(payload)



    }).then(function (response) { return handleResponse(response, true); })



      .catch(function (error) { console.error('[Great Bite cart subscription]', error); })



      .finally(function () { setLoading(false); });



  }



  function setSourceButtonBusy(source, busy) {



    if (!source) return;



    var button = source.matches && source.matches('button, input[type="submit"]')



      ? source



      : (source.querySelector ? source.querySelector('[type="submit"]') : null);



    if (!button) return;



    if (busy) {



      if (!button.dataset.gbOriginalText) {



        button.dataset.gbOriginalText = button.tagName === 'INPUT' ? button.value : button.textContent;



      }



      button.disabled = true;



      button.setAttribute('aria-busy', 'true');



      if (button.tagName === 'INPUT') button.value = 'ADDING…';



      else button.textContent = 'ADDING…';



    } else {



      button.disabled = false;



      button.removeAttribute('aria-busy');



      if (button.dataset.gbOriginalText) {



        if (button.tagName === 'INPUT') button.value = button.dataset.gbOriginalText;



        else button.textContent = button.dataset.gbOriginalText;



      }



    }



  }



  function addVariant(variantId, quantity, source) {



    if (addRequestInFlight) return Promise.resolve();



    addRequestInFlight = true;



    quantity = Math.max(1, parseInt(quantity, 10) || 1);



    var payload = sectionPayload();



    payload.items = [{ id: Number(variantId), quantity: quantity }];



    setOpen(true);



    setLoading(true);



    setSourceButtonBusy(source, true);



    optimisticCountAdd(quantity);



    return fetch(rootPath + 'cart/add.js', {



      method: 'POST',



      headers: {



        'Content-Type': 'application/json',



        'Accept': 'application/json',



        'X-Requested-With': 'XMLHttpRequest'



      },



      body: JSON.stringify(payload),



      cache: 'no-store'



    }).then(function (response) {



      return handleResponse(response, true);



    }).catch(function (error) {



      console.error('[Great Bite cart]', error);



      return fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })



        .then(function (r) { return r.ok ? r.json() : null; })



        .then(function (cart) { if (cart && typeof cart.item_count === 'number') syncCount(cart.item_count); })



        .catch(function () {});



    }).finally(function () {



      addRequestInFlight = false;



      setSourceButtonBusy(source, false);



      setLoading(false);



    });



  }



  function addForm(form) {



    if (addRequestInFlight) return Promise.resolve();



    addRequestInFlight = true;



    var data = new FormData(form);



    var qty = Math.max(1, parseInt(data.get('quantity'), 10) || 1);



    data.set('sections', getSectionId());



    data.set('sections_url', window.location.pathname + window.location.search);



    setOpen(true);



    setLoading(true);



    setSourceButtonBusy(form, true);



    optimisticCountAdd(qty);



    return fetch(rootPath + 'cart/add.js', {



      method: 'POST',



      headers: {



        'Accept': 'application/json',



        'X-Requested-With': 'XMLHttpRequest'



      },



      body: data,



      cache: 'no-store'



    }).then(function (response) {



      return handleResponse(response, true);



    }).catch(function (error) {



      console.error('[Great Bite cart]', error);



      return fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })



        .then(function (r) { return r.ok ? r.json() : null; })



        .then(function (cart) { if (cart && typeof cart.item_count === 'number') syncCount(cart.item_count); })



        .catch(function () {});



    }).finally(function () {



      addRequestInFlight = false;



      setSourceButtonBusy(form, false);



      setLoading(false);



    });



  }



  document.addEventListener('click', function (event) {



    var close = event.target.closest('[data-gb-close]');



    if (close) { event.preventDefault(); setOpen(false); return; }



    var sellingPlan = event.target.closest('[data-gb-selling-plan]');



    if (sellingPlan) {



      event.preventDefault();



      if (sellingPlan.classList.contains('is-active')) return;



      changeSellingPlan(sellingPlan.dataset.line, sellingPlan.dataset.quantity, sellingPlan.dataset.sellingPlan);



      return;



    }



    var qty = event.target.closest('[data-gb-qty]');



    if (qty) { event.preventDefault(); changeLine(qty.dataset.key, qty.dataset.quantity); return; }



    var upsell = event.target.closest('[data-gb-upsell]');



    if (upsell) { event.preventDefault(); addVariant(upsell.dataset.variantId, 1, upsell); return; }



    var opener = event.target.closest('[data-gb-cart-open], [data-cart-drawer-open]');



    if (opener) { event.preventDefault(); setOpen(true); }



  });



  document.addEventListener('keydown', function (event) {



    if (event.key === 'Escape' && getRoot() && getRoot().classList.contains('is-open')) setOpen(false);



  });



  document.addEventListener('submit', function (event) {



    var form = event.target;



    if (!(form instanceof HTMLFormElement)) return;



    if (form.closest(ROOT_SELECTOR)) return;



    var action = form.getAttribute('action') || '';



    if (!action.includes('/cart/add')) return;



    event.preventDefault();



    event.stopImmediatePropagation();



    addForm(form);



  }, true);



  ['cart:open', 'theme:cart-drawer:open', 'greatbite:cart:open'].forEach(function (name) {



    document.addEventListener(name, function () { setOpen(true); });



  });



  window.GreatBiteCart = {



    open: function () { setOpen(true); },



    close: function () { setOpen(false); },



    add: addVariant,



    changeSellingPlan: changeSellingPlan,



    refresh: function () {



      var id = getSectionId();



      if (!id) return Promise.resolve();



      setLoading(true);



      return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id), { headers: { 'Accept': 'application/json' } })



        .then(function (response) { return response.json(); })



        .then(function (data) { if (data[id]) replaceSection(data[id], true); })



        .finally(function () { setLoading(false); });



    }



  };



})();




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["great-bite-community-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const existing = window.GreatBiteCadenceRailV3;
    if (existing) {
      existing.initAll();
      return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const modulo = (value, total) => ((value % total) + total) % total;

    const init = section => {
      if (!section || section.dataset.gbReady === 'true') return;
      const viewport = section.querySelector('[data-gb-viewport]');
      const track = section.querySelector('[data-gb-track]');
      const originalCards = Array.from(section.querySelectorAll('[data-gb-card]'));
      const prev = section.querySelector('[data-gb-prev]');
      const next = section.querySelector('[data-gb-next]');
      const status = section.querySelector('[data-gb-status]');
      if (!viewport || !track || !originalCards.length || !prev || !next) return;

      section.dataset.gbReady = 'true';
      let cloneCount = 0;
      let physicalIndex = 0;
      let logicalIndex = 0;
      let offset = 0;
      let dragStart = 0;
      let dragOrigin = 0;
      let dragging = false;
      let timer = null;
      let resizeTimer = null;

      const metrics = () => {
        const cards = Array.from(track.querySelectorAll('[data-gb-card]'));
        const gap = parseFloat(window.getComputedStyle(track).gap) || 10;
        const cardWidth = cards[0].getBoundingClientRect().width;
        const step = cardWidth + gap;
        const lead = window.innerWidth < 750 ? 16 : Math.min(110, cardWidth * .38);
        return { cards, cardWidth, step, lead };
      };

      const announce = () => {
        if (status) status.textContent = `Video ${logicalIndex + 1} of ${originalCards.length}`;
      };

      const render = (animate = true) => {
        const { step, lead } = metrics();
        offset = Math.max(0, physicalIndex * step - lead);
        track.style.transitionDuration = animate && !reducedMotion.matches ? '560ms' : '0ms';
        track.style.transform = `translate3d(${-offset}px, 0, 0)`;
        announce();
      };

      const cleanClone = clone => {
        clone.dataset.gbClone = 'true';
        clone.removeAttribute('data-block-id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        clone.querySelectorAll('video').forEach(video => {
          video.pause();
          video.currentTime = 0;
          video.preload = 'none';
        });
        clone.classList.remove('is-playing');
        return clone;
      };

      const buildLoop = () => {
        track.querySelectorAll('[data-gb-clone]').forEach(clone => clone.remove());
        if (originalCards.length < 2) {
          cloneCount = 0;
          physicalIndex = 0;
          prev.disabled = true;
          next.disabled = true;
          render(false);
          return;
        }

        const baseWidth = originalCards[0].getBoundingClientRect().width || 280;
        const gap = parseFloat(window.getComputedStyle(track).gap) || 10;
        cloneCount = Math.min(originalCards.length, Math.ceil(viewport.clientWidth / (baseWidth + gap)) + 1);

        const before = document.createDocumentFragment();
        originalCards.slice(-cloneCount).forEach(card => before.appendChild(cleanClone(card.cloneNode(true))));
        track.insertBefore(before, track.firstChild);

        const after = document.createDocumentFragment();
        originalCards.slice(0, cloneCount).forEach(card => after.appendChild(cleanClone(card.cloneNode(true))));
        track.appendChild(after);

        physicalIndex = cloneCount + logicalIndex;
        prev.disabled = false;
        next.disabled = false;
        render(false);
      };

      const pauseAll = exceptCard => {
        track.querySelectorAll('[data-gb-card]').forEach(card => {
          if (card === exceptCard) return;
          const video = card.querySelector('video');
          if (video) video.pause();
          card.classList.remove('is-playing');
        });
      };

      const stopAutoplay = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const move = direction => {
        if (originalCards.length < 2) return;
        pauseAll();
        logicalIndex = modulo(logicalIndex + direction, originalCards.length);
        physicalIndex += direction;
        render();
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (section.dataset.autoplay !== 'true' || reducedMotion.matches || document.hidden) return;
        const interval = Math.max(3000, Number(section.dataset.interval) || 5000);
        timer = window.setInterval(() => move(1), interval);
      };

      const beginPlayback = card => {
        const video = card.querySelector('video');
        if (!video) return;
        pauseAll(card);
        stopAutoplay();
        card.classList.add('is-playing');
        video.play().catch(() => {
          card.classList.remove('is-playing');
          startAutoplay();
        });
      };

      track.addEventListener('click', event => {
        const card = event.target.closest('[data-gb-card]');
        if (!card) return;

        const sound = event.target.closest('[data-gb-sound]');
        const play = event.target.closest('[data-gb-play]');
        const video = event.target.closest('video');

        if (sound) {
          event.stopPropagation();
          const cardVideo = card.querySelector('video');
          if (!cardVideo) return;
          cardVideo.muted = !cardVideo.muted;
          sound.classList.toggle('is-muted', cardVideo.muted);
          sound.setAttribute('aria-label', cardVideo.muted ? 'Unmute video' : 'Mute video');
          return;
        }

        if (play) {
          beginPlayback(card);
          return;
        }

        if (video) {
          if (video.paused) beginPlayback(card);
          else {
            video.pause();
            card.classList.remove('is-playing');
            startAutoplay();
          }
        }
      });

      track.addEventListener('ended', event => {
        const video = event.target.closest('video');
        if (!video) return;
        const card = video.closest('[data-gb-card]');
        if (card) card.classList.remove('is-playing');
        video.currentTime = 0;
        startAutoplay();
      }, true);

      track.addEventListener('transitionend', event => {
        if (event.target !== track || originalCards.length < 2) return;
        if (physicalIndex >= cloneCount + originalCards.length) {
          physicalIndex -= originalCards.length;
          render(false);
        } else if (physicalIndex < cloneCount) {
          physicalIndex += originalCards.length;
          render(false);
        }
      });

      prev.addEventListener('click', () => {
        move(-1);
        startAutoplay();
      });

      next.addEventListener('click', () => {
        move(1);
        startAutoplay();
      });

      viewport.addEventListener('pointerdown', event => {
        if (event.target.closest('button, a, video')) return;
        dragging = true;
        dragStart = event.clientX;
        dragOrigin = offset;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
        stopAutoplay();
      });

      viewport.addEventListener('pointermove', event => {
        if (!dragging) return;
        offset = dragOrigin - (event.clientX - dragStart);
        track.style.transform = `translate3d(${-offset}px, 0, 0)`;
      });

      const finishDrag = event => {
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        const delta = event.clientX - dragStart;
        if (Math.abs(delta) > 38) {
          const direction = delta < 0 ? 1 : -1;
          logicalIndex = modulo(logicalIndex + direction, originalCards.length);
          physicalIndex += direction;
        }
        render();
        startAutoplay();
      };

      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);
      viewport.addEventListener('mouseenter', stopAutoplay);
      viewport.addEventListener('mouseleave', startAutoplay);
      viewport.addEventListener('focusin', stopAutoplay);
      viewport.addEventListener('focusout', startAutoplay);
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(buildLoop, 140);
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });

      buildLoop();
      startAutoplay();

      section.gbSelectBlock = blockId => {
        const selectedIndex = originalCards.findIndex(card => card.dataset.blockId === blockId);
        if (selectedIndex < 0) return;
        logicalIndex = selectedIndex;
        physicalIndex = cloneCount + selectedIndex;
        render();
      };
    };

    const initAll = root => {
      const scope = root || document;
      if (scope.matches && scope.matches('[data-gb-community]')) init(scope);
      scope.querySelectorAll('[data-gb-community]').forEach(init);
    };

    window.GreatBiteCadenceRailV3 = { initAll };
    initAll();
    document.addEventListener('shopify:section:load', event => initAll(event.target));
    document.addEventListener('shopify:block:select', event => {
      const card = event.target.closest('[data-gb-card]');
      const section = event.target.closest('[data-gb-community]');
      if (!card || !section) return;
      if (typeof section.gbSelectBlock === 'function') section.gbSelectBlock(card.dataset.blockId);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
